
import { useEffect, useRef, useState } from 'react'
import {
  IDropdown,
  IOption
} from './props'
import {
  Container,
  Error,
  Input,
  Label,
  Option,
  OptionContainer,
  Placeholder,
  SelectedContainer
} from './styles'

const Dropdown = ({
  options,
  value,
  label,
  placeholder,
  onChange,
  onBlur,
  error,
  input
}: IDropdown) => {
  const refDropdown = useRef<HTMLDivElement>(null)
  const [openDropdown, setOpenDropdown] = useState(false)
  const [data, setData] = useState<IOption[]>(options)

  const renderValue = () => {
    if (input) {
      return (
        <Input
          value={value}
          placeholder={placeholder}
          onChange={(e: any) => changeValueInput?.(e.target.value)}
          onBlur={(e: any) => changeValueInput?.(e.target.value)}
        />
      )
    }

    if (!value) return (
      <Placeholder>{placeholder}</Placeholder>
    );

    const obj = options.find((option) => option.value === value)

    return (
      <span>{obj?.label}</span>
    )

  }

  const returnOption = (option: IOption) => {
    const value_ = value ? value.toUpperCase() : '';
    const ocurrence = input ? `<strong>${value_}</strong>` : '';
    const label = input ? option.label.toUpperCase().replace(new RegExp(value_, "g"), ocurrence) : option.label;

    return (
      <Option
        className={option.value === value ? 'selected' : ''}
        key={option.value}
        onClick={() => changeValue(option)}
      >
        <span dangerouslySetInnerHTML={{ __html: label }} />
      </Option>
    )
  }

  const returnArrowSelected = () => {
    return (openDropdown
      ? (
        <svg id="up" xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
          <path fill="currentColor" d="M6.7 14.7q-.275-.275-.275-.7t.275-.7l4.6-4.6q.15-.15.325-.212T12 8.425q.2 0 .388.075t.312.2l4.6 4.6q.275.275.275.7t-.275.7q-.275.275-.7.275t-.7-.275L12 10.8l-3.9 3.9q-.275.275-.7.275t-.7-.275Z" />
        </svg>
      )
      : (
        <svg id="down" xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
          <path fill="currentColor" d="M12 14.975q-.2 0-.388-.075t-.312-.2l-4.6-4.6q-.275-.275-.275-.7t.275-.7q.275-.275.7-.275t.7.275l3.9 3.9l3.9-3.9q.275-.275.7-.275t.7.275q.275.275.275.7t-.275.7l-4.6 4.6q-.15.15-.325.213t-.375.062Z" />
        </svg>
      )
    )
  }

  const changeValue = (option: IOption) => {
    onChange?.(option.value)
    onBlur?.(option.value)
    setOpenDropdown(!openDropdown)
  }

  const changeValueInput = (value: string) => {
    onChange?.(value || '')
    onBlur?.(value || '')
    setOpenDropdown(true)
  }

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!refDropdown.current || refDropdown.current.contains(event.target as Element)) {
        return
      }
      setOpenDropdown(false)
    }
    document.addEventListener("mousedown", listener)
    document.addEventListener("touchstart", listener)
    return () => {
      document.removeEventListener("mousedown", listener)
      document.removeEventListener("touchstart", listener)
    }
  }, [refDropdown, () => setOpenDropdown(false)])

  useEffect(() => {
    if (!openDropdown) return

    if (refDropdown.current) {
      const { top } = refDropdown.current.getBoundingClientRect()
      const element = refDropdown.current.querySelector('ul')

      if (!element) return

      const isBottom = window.innerHeight - top < 200
      if (isBottom) {
        element.style.bottom = `0`
      }
    }
  }, [openDropdown])

  useEffect(() => {
    const ocurrences = options.filter((option) => option.label.toLowerCase().includes(value ? value.toLowerCase() : ''))
    const noOcurrences = options.filter((option) => !option.label.toLowerCase().includes(value ? value.toLowerCase() : ''))
    setData([...ocurrences, ...noOcurrences])
  }, [value])

  return (
    <Container ref={refDropdown}>
      <SelectedContainer
        onClick={() => setOpenDropdown(!openDropdown)}
        focus={openDropdown}
        error={error ? true : false}
        input={input || false}
      >
        {renderValue()}
        {returnArrowSelected()}
      </SelectedContainer>

      {label && (
        <Label
          focus={openDropdown}
          error={error ? true : false}
        >{label}</Label>)}

      {
        openDropdown && (
          <OptionContainer>
            {data.map((option) => returnOption(option))}
          </OptionContainer>
        )
      }

      {error && <Error>{error}</Error>}
    </Container>
  )
}

Dropdown.defaultProps = {
  error: ''
}

export default Dropdown